module.exports = __webpack_public_path__ + "static/media/DBKFoundryDiningHallA0024_design_clean_v002.b27b1b33.png";